export default {
  module: 'FORM',
  QUERY_PROCESS_HISTORY: { // 查询审批历史
    url: '/xdap-app/process/query/processHistory',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_CHARTS_CONFIG: {
    url: '/xdap-app/reportFormConfig/query/reportFormById',
    method: 'get',
    disableSuccessMsg: true
  },
  GET_CHART_DATA: {
    url: '/xdap-app/report/query/getIndicatorChart',
    method: 'post',
    // url: '/xdap-app/report/query/indicatorChart',
    // method: 'get',
    disableSuccessMsg: true
  },
  GET_PIE_DATA: {
    url: '/xdap-app/report/query/getPieChartData',
    method: 'post',
    // url: '/xdap-app/report/query/pieChartData',
    // method: 'get',
    disableSuccessMsg: true
  },
  GET_LINE_DATA: {
    url: '/xdap-app/report/query/getLineChartData',
    method: 'post',
    // url: '/xdap-app/report/query/lineChartData',
    // method: 'get',
    disableSuccessMsg: true
  },
  GET_BAR_DATA: {
    url: '/xdap-app/report/query/getBarChartData',
    method: 'post',
    // url: '/xdap-app/report/query/barChartData',
    // method: 'get',
    disableSuccessMsg: true
  },
  QUERY_PIE_DATA: {
    url: '/xdap-app/report/query/pieChartData',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_LINE_DATA: {
    url: '/xdap-app/report/query/lineChartData',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_BAR_DATA: {
    url: '/xdap-app/report/query/barChartData',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_GUIDE_LINE: {
    url: '/xdap-app/report/query/getGuidelineData',
    method: 'post',
    // url: '/xdap-app/report/query/guidelineData',
    // method: 'get',
    disableSuccessMsg: true
  },
  QUERY_RICH_CONTENT: {
    url: '/xdap-app/report/query/richTextContext',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_CALENDAR_MONTH_MARK_DATE: {
    url: '/xdap-app/report/query/monthTitle',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_CALENDAR_BY_MONTH: {
    url: '/xdap-app/report/query/month',
    method: 'post',
    disableSuccessMsg: true
  }
}
